<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-btn class="mr-5 ml-2"
             rounded
             color="primary"
             dark
             large
             @click="action"
             v-bind="attrs"
             v-on="on"
      >
        <v-icon>
          mdi-refresh
        </v-icon>
      </v-btn>
    </template>
    Refresh
  </v-tooltip>
</template>

<script>
export default {
  name: "RefreshTableHeader",
  props: {
    action: Function,
  },
};
</script>

<style scoped>

</style>